'use client'

import Icon from "@/components/etc/icon";
import Logo from "@/components/logo/logo";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useContext, useState } from "react";
import { FloatContext } from "@/context/moFloatMenuContext";
import { SignContext } from "@/context/signContext";
import { AuthContext } from "@/context/authContext";
import FloatBtn from "../etc/float_btn";
import PWAInstallButton from "@/components/etc/PWAInstallButton";
import LocaleSelect from "@/components/common/locale/locale_select";


export default function HeaderMo() {
    const { user, logout } = useContext(AuthContext)
    const { mypageShow, SetMypageShow, setBottomActive } = useContext(FloatContext)
    const { loginShow, SetLoginShow } = useContext(SignContext)


    return (
        <>
            <header id="mo-header">
                <div className={`inner`}>
                    <div className={`flex cener iiinner `}>
                        {/* <Icon icon={'bars'} onClick={e=> SetActive(!isActive)} /> */}
                        <Logo />
                        {/* <div className={`flex center`} style={{width:"calc(100% - 129px)"}}> */}
                        <PWAInstallButton />
                        {/* </div> */}


                        <div className="header-user-container">
                            {
                                user.is_authenticated
                                    ? <FloatBtn type={`mypage`} onClick={() => {
                                        SetMypageShow(!mypageShow)
                                        setBottomActive(false)
                                    }} />
                                    : <>
                                        <Icon icon={'subtract'} className="subtract" onClick={() => { SetLoginShow(!loginShow) }} />
                                        <LocaleSelect mode={'icon'}/>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}